import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceHome } from '../features/workspace/WorkspaceHome'
import { validateHomeScope } from '../features/workspace/homeScope'

function Home() {
  const { workspaceId } = Route.useParams()
  const navigate = Route.useNavigate()
  const scope = Route.useSearch()
  return (
    <WorkspaceHome
      key={workspaceId}
      workspaceId={workspaceId}
      scope={scope}
      onScopeChange={(search) => void navigate({ search, resetScroll: false })}
      onOpenConversation={(conversationId) => {
        void navigate({
          to: '/w/$workspaceId/conversations/$conversationId',
          params: { workspaceId, conversationId },
        })
      }}
    />
  )
}

export const Route = createFileRoute('/w/$workspaceId/')({
  component: Home,
  validateSearch: validateHomeScope,
})
